module.exports = __webpack_public_path__ + "img/gj.05cb2f67.svg";